import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Autocomplete, TextField } from '@mui/material';

import { translateErrorMessage } from './FormConsts';

type Option = {
  id: string | number;
  label: string;
  description?: string;
};

type Props = {
  name: string;
  label: string;
  options: Option[];
  required?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string;
  slotProps?: any;
};

export const AutocompleteField = ({
  name,
  label,
  options,
  required = false,
  fullWidth = true,
  disabled = false,
  placeholder,
  helperText,
  slotProps
}: Readonly<Props>) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? t('validation.required') : false }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const selectedOption = options.find(option => option.id === value) ?? null;

        return (
          <Autocomplete
            options={options}
            getOptionLabel={option => option.label}
            value={selectedOption}
            onChange={(_, newValue) => {
              onChange(newValue ? newValue.id : '');
            }}
            disabled={disabled}
            renderInput={params => (
              <TextField
                {...params}
                label={label}
                required={required}
                fullWidth={fullWidth}
                error={!!error}
                helperText={error ? translateErrorMessage(error) : helperText}
                placeholder={placeholder}
                slotProps={slotProps}
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
        );
      }}
    />
  );
};
